'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function Duration(props) {
    return (React__default.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
        React__default.default.createElement("path", { d: "M14.7071 8.70613C15.0976 8.31561 15.0976 7.68244 14.7071 7.29192L11.7071 4.29192C11.3166 3.90139 10.6834 3.90139 10.2929 4.29192C9.90237 4.68244 9.90237 5.31561 10.2929 5.70613L11.5859 6.99917H4.41436L5.70726 5.70628C6.09778 5.31576 6.09778 4.68259 5.70726 4.29207C5.31673 3.90154 4.68357 3.90154 4.29304 4.29207L1.29304 7.29207L1.29068 7.29443C0.90237 7.68513 0.903106 8.31665 1.29289 8.70643L4.29289 11.7064C4.68342 12.097 5.31658 12.097 5.70711 11.7064C6.09763 11.3159 6.09763 10.6827 5.70711 10.2922L4.41406 8.99917H11.5856L10.2927 10.2921C9.90222 10.6826 9.90222 11.3158 10.2927 11.7063C10.6833 12.0968 11.3164 12.0968 11.707 11.7063L14.7071 8.70613Z", fill: "#565656" })));
}

module.exports = Duration;
//# sourceMappingURL=Duration.js.map
